import { IPhone } from "shared/types";
import { CALLING_CODES } from "shared/constants";

// Format phone number with calling code to string
export const formatPhone = (phone: IPhone): string =>
  phone.number ? `+${CALLING_CODES[phone.code]} ${phone.number}` : "";
